import React, { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CButton } from '@app/components/Common';
import { Text, View } from '@/styles/reactnative';
import { COLORS } from '@app/constants';
import useTradeStore from '../../../../../../hooks/trade/tradeStore';
import { useTradeSetting } from '../../../../../../hooks/trade/tradeSetting';
import { useTradeApi } from '../../../../../../hooks/trade/tradeApi';
import { useOrderBook } from '../../../../../../hooks/trade/orderBook';
import { useTradePosition } from '../../../../../../hooks/trade/tradePosition';
import { Col, message, Modal, Row } from 'antd';
import BigNumber from 'bignumber.js';
import { useTradeModalStore } from '../../../../../../hooks/trade/modalStore';
import CheckPositionModal from '../../../../../../components/CheckPositionModal';
import { useMyProfile } from '../../../../../../hooks/user/myprofile';
import { ThemeContext } from '../../../../../../../theme/ThemeProvider';
import { useMitOrder } from '../../../../../../hooks/trade/mitorder';
import { useIndexPrice } from '@/app/hooks/trade/indexprice';

import useSound from 'use-sound';
import order from '../../../../../../../assets/order.mp3';
import { useDisableScroll } from '@utils/useDisableScroll.tsx';
import * as console from 'node:console';
import { useBinanceWebSocketStore } from '@app/hooks/binanceWebsocketStore.ts';
import { useCiTradeWebSocketStore } from '@app/hooks/ciTradeWebsocketStore.ts';
import { USER_LOG_TYPE, useUserLogger } from '@/app/hooks/userLogger';
import { useBalance } from '@/app/hooks/user/mybalance';
import { SETTING_TYPE_TRADE } from '@/app/constants/SETTING';
import { useSetting } from '@/app/hooks/user/mysetting';
import { getSetting } from '@/app/hooks/user/mysetting';
import { activityLogger, Actions } from '@/utils/activityLogger';
const DerivativesFormBtns = () => {
  const [orderSound] = useSound(order, { volume: 1 });

  const { t } = useTranslation();
  const { data: tradeStore, mutate: mutateStore } = useTradeStore();
  const [long_short, setLongShort] = React.useState('L');

  const [open, setOpen] = React.useState(false);

  const { textw, PrimaryBorder } = useContext(ThemeContext).theme.COLORS;

  const { data: mitdata, mutate: mutateMit } = useMitOrder();
  const { fee } = useMyProfile();

  const { data: tradeModalStore, mutate: mutateModalStore } =
    useTradeModalStore();
  const { data: tradeSetting } = useTradeSetting(tradeStore?.ep_id);
  const { createOrder } = useTradeApi(); // ✅ Context 기반 API Hook 사용
  const { mutate: mutateOrderBook } = useOrderBook(tradeStore?.ep_id);
  const { mutateUserLog, getOrderLog } = useUserLogger();
  const { getPrice } = useIndexPrice(tradeStore?.ep_id);

  const { mutate: mutatePosition } = useTradePosition();
  const currency = tradeStore?.pairs?.split('/')[1];
  const coin = tradeStore?.pairs?.split('/')[0];

  const [checkmit, setCheckmit] = React.useState('');

  const tradePrice = useCiTradeWebSocketStore((s) => s.tradePrice);
  const { data: balance } = useBalance(currency, 1);
  const { data: position } = useTradePosition();
  const { data, updateSetting } = useSetting(SETTING_TYPE_TRADE);

  // 단방향 모드 : TG : O, 양방향 모드 TG :
  const TG = getSetting(data, 'TG', 'O');
  // 반대 포지션의 증거금 계산 함수
  const getOppositePositionMargin = (orderDirection) => {
    if (!position || !tradeStore?.ep_id) return 0;

    // 현재 거래쌍의 포지션 찾기
    const currentPosition = position.find(
      (pos) => pos.exchange_pairs_id == tradeStore?.ep_id
    );

    if (!currentPosition || !currentPosition.margin) return 0;

    // 주문 방향과 반대인지 확인
    const isOppositeDirection =
      (currentPosition.long_short === 'L' && orderDirection === 'S') ||
      (currentPosition.long_short === 'S' && orderDirection === 'L');

    // 반대 포지션이면 증거금 반환, 아니면 0
    return isOppositeDirection ? Number(currentPosition.margin) : 0;
  };

  // 반대 방향 주문 시 → 기존 포지션 청산 후 새 포지션 생성
  // 기존 포지션의 증거금이 해제되어 재사용 가능
  // 사용가능잔고 = 기본잔고 + 반대포지션증거금
  // 양방향은 적용 안됨, 단방향 모드만
  // 근데 최종적으로 드리고 주문은 API 안태우므로 가용잔액으로 판단 .
  const calculateAvailableBalance = (orderDirection) => {
    const baseBalance = new BigNumber(balance?.balance || 0).minus(
      balance?.lockbalance || 0
    );

    const oppositeMargin = getOppositePositionMargin(orderDirection);

    // return TG === 'O' ? baseBalance.plus(oppositeMargin).toNumber() : baseBalance.toNumber();
    // 근데 최종적으로 드리고 주문은 API 안태우므로 가용잔액으로 판단 .
    return baseBalance.toNumber();
  };

  // 필요 증거금 계산 함수
  const calculateRequiredMargin = () => {
    if (!tradeStore?.order_amount || !tradeStore?.order_price) return 0;

    const main_sub = localStorage.getItem('main_sub') || 'M';
    const leverage = tradeSetting?.leverage || 1;
    const price = Number(tradeStore?.order_price);
    const amount = Number(tradeStore?.order_amount);

    console.log('tradeStore ::: ', tradeStore);

    //M 일때는 amount : 0.20785 -> 레버리지 미반영
    // Sub 일 때는 테더의 usdt 그대로 amount 사용 : 32999.99999 -> 레버리지 미반영
    if (main_sub === 'M') {
      const margin = new BigNumber(price)
        .multipliedBy(amount)
        .dividedBy(leverage);
      const marginfee = margin.toNumber() * 0;

      return margin.plus(marginfee).toNumber();
    } else {
      const margin = new BigNumber(amount).dividedBy(leverage).toNumber(); //.multipliedBy(leverage).toNumber();
      const marginfee = margin * 0;
      return margin + marginfee;
    }
  };

  const mitorder = useMemo(() => {
    return (longshort, price) => {
      if (!tradeStore?.order_amount) {
        message.error('Check your order amount.');
        return;
      }

      // availableBalance 가용 가능한 자산
      // calcurrencyAmount 필요 증거금
      // available 이 calcurrencyAmount 보다 작으면 주문 불가

      const availableBalance = calculateAvailableBalance(longshort);

      //  console.log('availableBalance', availableBalance)
      const currencyAmount = calculateRequiredMargin();
      //  console.log('currencyAmount', currencyAmount)

      if (availableBalance < currencyAmount) {
        message.error('ERROR_NOBALANCE');
        return;
      }

      if (!tradeStore?.trigger_price) {
        message.error('Enter Trigger Price');
        return;
      }

      const tempdata: any = [];
      const check: any = false;

      // if (mitdata?.['MIT' + tradeStore?.ep_id]) {
      // 	tempdata = [...mitdata?.['MIT' + tradeStore?.ep_id]]

      // 	check = mitdata?.['MIT' + tradeStore?.ep_id]?.find(
      // 		i =>
      // 			i?.price === price &&
      // 			i?.longshort === longshort &&
      // 			i?.limit_market == tradeStore?.limit_market
      // 	)
      // }

      let amount = new BigNumber(tradeStore?.order_amount)
        .dividedBy(tradeSetting?.leverage)
        .toNumber();

      if (check) {
        amount = BigNumber(amount)
          .plus(check?.amount || 0)
          .toNumber();
        tempdata[tempdata.indexOf(check)].amount = amount;
      } else {
        tempdata.push({
          type: 'MIT',
          amount: amount,
          trigger_price: tradeStore?.trigger_price,
          trigger_type: tradeStore?.trigger_type,
          limit_market: tradeStore?.limit_market,
          longshort: longshort,
          main_sub: localStorage.getItem('main_sub') || 'M',
          ep_id: tradeStore?.ep_id,
          cross_iso: tradeSetting?.cross_iso,
          leverage: tradeSetting?.leverage,
          post_only: tradeStore?.post_only ? 1 : 0,
          reduce_position: tradeStore?.reduce_only ? 1 : 0,
          tpsl: tradeStore?.tpsl,
          tp: tradeStore?.tp,
          tptype: tradeStore?.tptype,
          sl: tradeStore?.sl,
          sltype: tradeStore?.sltype,
          price: price,
          created_at: new Date(),
        });
      }

      mutateMit(tempdata, tradeStore?.ep_id).then(() => {
        const data = tempdata[0];
        mutateUserLog({
          log: getOrderLog(
            {
              ...data,
              is_triggered:
                data.trigger_type && data.trigger_price ? true : false,
            },
            USER_LOG_TYPE.ORDER_OPEN
          ),
          data,
        });
      });

      // message.success('Trigger Order Added');
    };
  }, [
    tradeStore?.ep_id,
    mitdata,
    mutateMit,
    tradeStore?.order_amount,
    tradeStore?.leverage,
  ]);

  const sendOrder = async (long_short) => {
    if (tradeStore?.tpsl) {
      if (isNaN(tradeStore?.tp) || isNaN(tradeStore?.sl)) {
        message.error(t('checkTpSl'));
      }

      const current = getPrice(tradeStore?.ep_id);

      if (long_short == 'L') {
        if (current > tradeStore?.tp) {
          message.error(t('tpPriceLowerThanIndex'));
          return;
        }

        if (current < tradeStore?.sl) {
          message.error(t('slPriceHigherThanIndex'));
          return;
        }
      } else {
        if (current < tradeStore?.tp) {
          message.error(t('tpPriceHigherThanIndex'));
          return;
        }

        if (current > tradeStore?.sl) {
          message.error(t('slPriceLowerThanIndex'));
          return;
        }
      }
    }

    // 현재 시장 가격 가져오기
    const currentMarketPrice = getPrice(tradeStore?.ep_id);

    // 지정가 주문 여부 확인
    const isLimitOrder =
      tradeStore?.limit_market?.toUpperCase() == 'L' ||
      tradeStore?.limit_market?.toUpperCase() == 'LIMIT';

    // 최종 주문 타입 결정
    let finalOrderType = isLimitOrder ? 'L' : 'M';

    if (isLimitOrder) {
      // 주문 가격과 현재 가격 비교
      const orderPrice = Number(tradeStore?.order_price);

      // 화면에 가격 비교 정보 표시 (디버깅용)
      // message.info(`가격 비교 - 주문: ${orderPrice}, 시장: ${currentMarketPrice}`);

      // 불리한 가격인지 확인
      const isPriceUnfavorable =
        (long_short === 'L' && orderPrice > currentMarketPrice) || // 매수인데 지정가가 시장가보다 높음
        (long_short === 'S' && orderPrice < currentMarketPrice); // 매도인데 지정가가 시장가보다 낮음

      // 불리한 가격이면 시장가로 전환
      if (isPriceUnfavorable) {
        finalOrderType = 'M';
        // message.warning('불리한 가격으로 시장가 전환됨');
      }
    }

    const orderParams: any = {
      ep_id: tradeStore?.ep_id,
      main_sub: localStorage.getItem('main_sub') || 'M',
      long_short: long_short,
      cross_iso: tradeSetting?.cross_iso,
      leverage: tradeSetting?.leverage,
      reduce_position: tradeStore.reduce_only ? 1 : 0,
      post_only: tradeStore?.post_only ? 1 : 0,
      limit_market: finalOrderType,
      price: tradeStore?.order_price,
      amount: new BigNumber(tradeStore?.order_amount)
        .dividedBy(tradeSetting?.leverage)
        .toNumber(),
      tpsl: tradeStore?.tpsl,
      tp: tradeStore?.tp,
      sl: tradeStore?.sl,
      tptype: tradeStore?.tptype,
      sltype: tradeStore?.sltype,
    };

    // Time In Force 파라미터 추가 (지정가 주문일 때만)
    if (finalOrderType === 'L') {
      const timeInForce = tradeStore?.time_in_force || 'GTC';
      orderParams.time_in_force = timeInForce;

      if (timeInForce === 'GTD' && tradeStore?.gtd_expiry) {
        orderParams.gtd_expiry = tradeStore.gtd_expiry;
      }
    }

    const result = await createOrder(orderParams); // ✅ Demo/Real 자동 선택

    // console.log('/trade/order 1');

    if (!tradeModalStore?.sound) {
      orderSound();
    }

    mutateStore({ ...tradeStore, order_amount: 0 });
    if (result.result.success) {
      mutateUserLog({
        log: getOrderLog(orderParams, USER_LOG_TYPE.ORDER_OPEN),
        data: orderParams,
      });

      // Activity Logger 추가
      activityLogger.log(Actions.Trading.ORDER_CREATE, {
        extraData: {
          symbol: tradeStore?.pairs,
          side: long_short === 'L' ? 'LONG' : 'SHORT',
          orderType: finalOrderType === 'L' ? 'LIMIT' : 'MARKET',
          price: tradeStore?.order_price,
          quantity: orderParams.amount,
          leverage: tradeSetting?.leverage,
          marginType: tradeSetting?.cross_iso === 'C' ? 'CROSS' : 'ISOLATED',
          reduceOnly: !!tradeStore.reduce_only,
          postOnly: !!tradeStore?.post_only,
          tpsl: !!tradeStore?.tpsl,
          tp: tradeStore?.tp,
          sl: tradeStore?.sl,
          epId: tradeStore?.ep_id,
        },
      });

      mutateOrderBook();
      mutatePosition();

      setTimeout(() => {
        mutateOrderBook();
        mutatePosition(null);
      }, 500);

      message.success(t('orderCompleted'));
    } else {
      if (result?.result?.message == 'ERROR_MAXAMOUNT') {
        message.error(
          t('ERROR_MAXAMOUNT') +
            ' / MAX AMOUNT : ' +
            BigNumber(result?.result?.max).toFormat(3)
        );
      } else {
        message.error(t(result?.result?.message + ''));
      }
    }
  };

  useDisableScroll(checkmit == 'L' || checkmit == 'S');

  const handleTouchMove = (e) => {
    e.stopPropagation();
  };

  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Modal
          open={checkmit == 'L' || checkmit == 'S'}
          title={t('ordercheck') + ''}
          onCancel={() => {
            setCheckmit('');
          }}
          onOk={() => {
            mitorder(checkmit, tradeStore?.order_price);
            setCheckmit('');
          }}
          cancelText={t('cancel')}
          okText={t('confirm')}
        >
          <div onTouchMove={handleTouchMove}>
            <Row
              style={{
                borderBottom: `1px solid ${PrimaryBorder}`,
                padding: '5px 0',
              }}
            >
              <Col span={12}>{t('pairs')}</Col>
              <Col span={12} style={{ fontWeight: 'bold' }}>
                {tradeStore?.pairs}
              </Col>
            </Row>
            <Row
              style={{
                borderBottom: `1px solid ${PrimaryBorder}`,
                padding: '5px 0',
              }}
            >
              <Col span={12}>Price</Col>
              <Col span={12} style={{ fontWeight: 'bold' }}>
                {tradeStore?.limit_market == 'CM'
                  ? t('market')
                  : tradeStore?.order_price}
              </Col>
            </Row>
            <Row
              style={{
                borderBottom: `1px solid ${PrimaryBorder}`,
                padding: '5px 0',
              }}
            >
              <Col span={12}>Trigger</Col>
              <Col span={12} style={{ fontWeight: 'bold' }}>
                {t('market')}
                {tradeStore?.trigger_type == 'BIG' ? ' <=' : ' >='}{' '}
                {tradeStore?.trigger_price}
              </Col>
            </Row>
            <Row
              style={{
                borderBottom: `1px solid ${PrimaryBorder}`,
                padding: '5px 0',
              }}
            >
              <Col span={12}>Amount</Col>
              <Col span={12} style={{ fontWeight: 'bold' }}>
                {tradeStore?.order_amount}
              </Col>
            </Row>
          </div>
        </Modal>

        <CButton
          title={t('buyLong')}
          onClick={() => {
            // tradeStore에 주문 방향 저장
            mutateStore({
              ...tradeStore,
              long_short: 'L',
            });

            // region 트리거 (지정가, 시장가 ) 주문
            if (
              tradeStore?.limit_market == 'CM' ||
              tradeStore?.limit_market == 'CL'
            ) {
              // 확인 모달 띄운 후 주문 실행
              if (!tradeModalStore?.skip) {
                if (!tradeStore?.order_amount) {
                  message.error(t('pleaseEnterYourOrderValue'));  // ← 수정

                  return;
                }
                setCheckmit('L');
              } else {
                mitorder('L', tradeStore?.order_price);
              }
            } else {
              // 일반 주문
              if (tradeModalStore?.skip) {
                if (!tradeStore?.order_amount) {
                  message.error(t('pleaseEnterYourOrderValue'));  // ← 수정

                  return;
                }
                sendOrder('L');
              } else {
                setLongShort('L');
                setOpen(true);
              }
            }
          }}
          style={{
            flex: 1,
            background: COLORS.lightGreen,
            color: COLORS.white,
            marginRight: 10,
            padding: 8,
            borderRadius: 2,
            cursor: 'pointer',
          }}
        />
        <CButton
          title={t('sellShort')}
          onClick={() => {
            // tradeStore에 주문 방향 저장
            mutateStore({
              ...tradeStore,
              long_short: 'S',
            });

            if (
              tradeStore?.limit_market == 'CM' ||
              tradeStore?.limit_market == 'CL'
            ) {
              if (!tradeModalStore?.skip) {
                if (!tradeStore?.order_amount) {
                  message.error(t('pleaseEnterYourOrderValue'));  // ← 수정

                  return;
                }
                setCheckmit('S');
              } else {
                mitorder('S', tradeStore?.order_price);
              }
            } else {
              if (tradeModalStore?.skip) {
                if (!tradeStore?.order_amount) {
                  message.error(t('pleaseEnterYourOrderValue'));  // ← 수정

                  return;
                }
                sendOrder('S');
              } else {
                setLongShort('S');
                setOpen(true);
              }
            }
          }}
          style={{
            flex: 1,
            background: COLORS.lightRed,
            color: COLORS.white,
            padding: 8,
            borderRadius: 2,
            cursor: 'pointer',
          }}
        />

        <CheckPositionModal
          open={open}
          setOpen={setOpen}
          long_short={long_short}
        />
      </View>

      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          marginTop: 8,
          padding: 5,
          flexWrap: 'wrap',
          gap: 5,
        }}
      >
        <Text style={{ fontSize: 12, color: COLORS.lightGray }}>
          {t('feeRate')}
        </Text>
        <Text
          style={{
            fontSize: 12,
            color: textw,
            background: 'transparent',
            whiteSpace: 'nowrap',
            letterSpacing: -0.25,
          }}
        >
          {t('maker')} {fee?.maker_fee}% / {t('taker')} {fee?.taker_fee}%
        </Text>
      </View>

      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          marginTop: 3,
          padding: 5,
        }}
      >
        <Text style={{ fontSize: 12, color: COLORS.lightGray }}>
          {t('minmargin')}
        </Text>
        <Text style={{ fontSize: 12, color: textw }}>
          {tradeStore?.minimum_price 
            ? parseFloat(tradeStore.minimum_price).toString() 
            : 0} {coin}
        </Text>
      </View>
    </>
  );
};

export default DerivativesFormBtns;
